import { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  BodyM,
  BrandM,
  BrandS,
  LabelM,
} from '@sorare/core/src/atoms/typography';
import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { TermsDialog } from '@sorare/core/src/components/conversionCredit/TermsDialog';
import { RewardConfigImage } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigImage';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { TutorialBezel } from '../../TutorialBezel';
import { ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY } from '../../utils';

const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
`;
const StyledBezel = styled(Bezel)`
  padding: var(--double-unit);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  justify-self: center;
`;
const TextWrapper = styled(Horizontal)`
  align-items: baseline;
`;

const StyledButtonBase = styled(ButtonBase)`
  text-decoration: underline;
  color: var(--c-nd-600);
  width: 100%;
  text-align: center;

  @media ${tabletAndAbove} {
    position: absolute;
    bottom: calc(-1 * var(--quadruple-unit));
  }
`;

export const GetRewarded = () => {
  const [openTermsDialog, setOpenTermsDialog] = useState(false);
  return (
    <Vertical style={{ position: 'relative' }}>
      <TutorialBezel color="#757AEB">
        <Vertical gap={3} center>
          <Vertical center className="text-center">
            <BrandM>
              <FormattedMessage
                id="GetRewarded.title"
                defaultMessage="Get rewarded"
              />
            </BrandM>
            <BodyM color="var(--c-nd-600)">
              <FormattedMessage
                id="GetRewarded.description"
                defaultMessage="Claim your reward right after the game"
              />
            </BodyM>
          </Vertical>
          <StyledBezel background="var(--c-black)" borderColor="#757aeb">
            <Horizontal gap={2}>
              <RewardConfigImage
                anyRewardConfig={{
                  __typename: 'MonetaryRewardConfig',
                  id: '1',
                }}
                size={5}
              />
              <TextWrapper gap={0.5}>
                <BrandM>
                  <FormattedNumber
                    value={ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY}
                    style="currency"
                    currency="USD"
                  />
                </BrandM>
                <BrandS color="var(--c-nd-600)">
                  <FormattedMessage
                    id="GetRewarded.reward"
                    defaultMessage="Top Reward"
                  />
                </BrandS>
              </TextWrapper>
            </Horizontal>
            <StyledNeonEdge showHalo="never" color="#c9ccfe" />
          </StyledBezel>
        </Vertical>
        {!!openTermsDialog && (
          <TermsDialog
            onClose={() => setOpenTermsDialog(false)}
            terms="quickPlayTerms"
          />
        )}
      </TutorialBezel>
      <StyledButtonBase onClick={() => setOpenTermsDialog(true)}>
        <LabelM color="var(--c-nd-600)">
          <FormattedMessage
            id="GetRewarded.quickplayRulesApply"
            defaultMessage="Quickplay Rules Apply"
          />
        </LabelM>
      </StyledButtonBase>
    </Vertical>
  );
};
